module.exports = __webpack_public_path__ + "img/img_g1@2x.0744dc79.png";